import { axios } from '@/utils/request'

export default {
    create(info){
        return axios.post('/api/services/app/Role/Create',info)
    },
    update(info){
        return axios.put('/api/services/app/Role/Update',info)
    },
    delete(id){
        return axios.delete('/api/services/app/Role/Delete?Id='+id)
    },
    get(id){
        return axios.get('/api/services/app/Role/Get?Id='+id)
    },
    getAll(page){
        return axios.get('/api/services/app/Role/GetAll',{params:page})
    },
    getSchools(){
        return axios.get('/api/services/app/Role/GetSchools')
    },
    getAllPermissions(){
        return axios.get('/api/services/app/Role/GetAllPermissions')
    }
}